import React from 'react';

function Hackathon() {
  return (
    <div className="sec-box price section-padding" id="price">
      <div className="sec-head mb-80 wow fadeInUp">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <h3>
              <span className="main-color">Hackathon</span>
            </h3>
          </div>
        </div>
      </div>
      <div className="row md-marg">
        <div className="col-lg-2 valign">
          
        </div>
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".4s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">2024</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">Alisgo</h2>
              </div>
              <div className="feat">
                <ul className="rest">
                  <div className="mb-20">
                    <img src="/sol.png" alt="solanae" />
                  </div>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Blockchain Integrations (Solana-Specific)</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Solana Wallet Connectivity</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                    Token & Payment Mechanisms
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span> On-chain Data Storage / Usage</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Your project alway be priority</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                  <a
                    href="https://alis-go.vercel.app/"
                    className="butn butn-md butn-bord radius-5 text-u full-width"
                  >
                    <span>View Live</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div className="item full-width wow fadeIn" data-wow-delay=".6s">
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">2025</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex align-items-end pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color">Astrodome</h2>
              </div>
              <div className="feat">
                <ul className="rest">
                <div className="mb-20">
                    <img src="/astro.png" alt="solanae" />
                  </div>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span> Front-end & dApp UI</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Ecosystem & Dev Tools Used</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                    Blockchain Integrations (Solana-Specific)
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Wallet & Identity Integration</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Wallet & Identity Integration</span>
                  </li>
                  
                </ul>
              </div>
              <div className="text-center mt-50">
                <div className="butn-presv">
                  <a
                    href="https://astrodome-one.vercel.app/"
                    className="butn butn-md butn-bord radius-5 text-u full-width"
                  >
                    <span>View Live</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hackathon;